import axios from 'axios';

export default (startDate, endDate) =>
  new Promise((resolve, reject) => {
    axios
      .get(process.env.VUE_APP_API_ADMIN_LOCATION + 'users/signup-stats', {
        params: {
          start: startDate, // 'YYYY-MM-DD' in ICT
          end: endDate, // 'YYYY-MM-DD' in ICT
        },
      })
      .then(({ data }) => {
        resolve(data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
